<div class="mainWrapper">
  <div class="header">
    <div class="topWrapper">
      <h2>
        <a [routerLink]="['/model/list', car?.carModel?.manufacturer?.id]"
          >{{ car?.carModel?.manufacturer?.description }}
        </a>
        <a [routerLink]="['/modification/list', car?.carModel?.id]">{{
          car?.carModel?.description
        }}</a>
        {{ car?.description }}
      </h2>
      <div class="linksWrapper">
        <a
          mat-flat-button
          color="primary"
          [routerLink]="['/modification/profile', car?.id, 'items']"
          >Товары</a
        >
        <a mat-button color="primary" [routerLink]="['/modification/profile', car?.id, 'info']"
          >Информация</a
        >
      </div>
    </div>
    <span> {{ getEngineDescription() }} {{ getHorsePower() }} </span>
  </div>
  <mat-drawer-container class="mainContainer" autosize>
    <mat-drawer class="sideMenu" #sideMenu mode="side" position="start" opened="true">
      <div class="groups">
        <div class="btnWrapper">
          <button class="actionBtn" mat-flat-button color="primary" (click)="addItem()">
            <mat-icon>add</mat-icon> Добавить товар
          </button>
        </div>
        <app-folder-list (toggleEvent)="getProducts($event)"></app-folder-list>
      </div>
    </mat-drawer>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <div class="mainTable">
      <div class="headerTable">
        <h2>{{ selectedFolder?.name || 'Все товары' }}</h2>
        <button mat-icon-button *ngIf="selectedFolder" color="warn" (click)="clearFolder()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
      <div class="prodTable">
        <table
          mat-table
          [dataSource]="tableProducts"
          class="productTable"
          matSort
          (matSortChange)="sortData($event)"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>ID</th>
            <td mat-cell *matCellDef="let row">
              <a [routerLink]="['/product', row.id]" target="_blank">
                {{ row.id }}
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Наименование</th>
            <td
              mat-cell
              *matCellDef="let row"
              [matTooltip]="row.description_long"
              matTooltipPosition="above"
            >
              {{ row.description }}
            </td>
          </ng-container>
          <ng-container matColumnDef="img">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear></th>
            <td mat-cell *matCellDef="let row">
              <div class="hoverImg" (contextmenu)="onRightClick($event, row)">
                <img [src]="getImg(row)" class="thumbImg" alt="" />
                <img [src]="getImg(row)" class="openImg" alt="" />
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="brand">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Производитель</th>
            <td mat-cell *matCellDef="let row">
              {{ row.brand.description }}
            </td>
          </ng-container>
          <ng-container matColumnDef="article">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Артикул</th>
            <td mat-cell *matCellDef="let row">
              <div class="articleWrapper">
                <span>{{ row.article }}</span>
                <button mat-icon-button color="primary" (click)="openAnalogies(row)">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Цена</th>
            <td mat-cell *matCellDef="let row">
              <p
                matTooltip="{{ supportService.formatMoney(row.price) }}"
                matTooltipPosition="left"
                (contextmenu)="onRightClick($event, row)"
              >
                {{ supportService.formatMoney(row.retail) }}
              </p>
            </td>
          </ng-container>
          <ng-container matColumnDef="stock">
            <th mat-header-cell *matHeaderCellDef>Кол-во</th>
            <td mat-cell *matCellDef="let row">
              <div class="stockWrapper">
                <div
                  *ngFor="let wh of sortStock(row)"
                  matTooltip="{{ wh.warehouse.description }}"
                  class="stockCell {{ wh.quan > 0 ? 'myStock' : 'otherStock' }}"
                >
                  {{ +wh.quan }}
                </div>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="cell">
            <th mat-header-cell *matHeaderCellDef>Адрес</th>
            <td mat-cell *matCellDef="let row">
              {{ getWarehouse(row)?.cell }}
            </td>
          </ng-container>
          <ng-container matColumnDef="menu">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <div class="menuWrapper drop-padding">
                <button mat-icon-button (click)="openMoveProd(row.id)">
                  <mat-icon>timeline</mat-icon>
                </button>
                <button mat-icon-button (click)="openPrintDialog(row)">
                  <mat-icon>print</mat-icon>
                </button>
                <button mat-icon-button *ngIf="!productInCart(row.id)" (click)="addToCart(row)">
                  <mat-icon>add_shopping_cart</mat-icon>
                </button>
                <mat-form-field
                  *ngIf="productInCart(row.id)"
                  appearance="outline"
                  class="quanCatalogue"
                >
                  <mat-label>Кол-во</mat-label>
                  <input
                    matInput
                    type="number"
                    [formControl]="getProductCartControl(row.id)"
                    (input)="changeCartQuan(row.id)"
                    placeholder="Кол-во"
                  />
                  <button
                    matSuffix
                    mat-icon-button
                    color="warn"
                    aria-label="Удалить"
                    type="button"
                    (click)="removeFromCart(row)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
                <button mat-icon-button (click)="removeProduct(row)" color="warn">
                  <mat-icon>remove</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let element; columns: columnsToDisplay"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="8">Не могу ничего найти :(</td>
          </tr>
        </table>
      </div>
      <mat-paginator
        #paginator
        [length]="resultsLength"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 50, 100]"
      ></mat-paginator>
    </div>
  </mat-drawer-container>
</div>
<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
></div>
<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="setNewPrice(item)"><mat-icon>edit</mat-icon> Новая цена</button>
    <button mat-menu-item (click)="updateName(item)">
      <mat-icon>edit</mat-icon> Изменить наименование
    </button>
    <button mat-menu-item (click)="addImage(item)">
      <mat-icon>image</mat-icon> Добавить изображение
    </button>
    <button mat-menu-item (click)="removeDouble(item)">
      <mat-icon>remove</mat-icon> Удалить двойноую карточку
    </button>
  </ng-template>
</mat-menu>
